<template>
  <div>
    <b-list-group v-for="item in problemsSaved" :key="item.id" class="mx-3">
      <help-saved-item
        :text="item.text"
        :id="item.id"
        @onClick="goDetailSolving"
        @onDelete="confirmationDelete(item.id)"
      />
    </b-list-group>
    <modal-confirmation
      ref="modalConfirmation"
      text="Are you sure delete this item?"
      @onAccept="handleDeleteProblemSaved"
    />
  </div>
</template>
<script>
import { ModalConfirmation } from '@/components/general/modal';
import HelpSavedItem from './HelpSavedItem.vue';

export default {
  components: { HelpSavedItem, ModalConfirmation },
  props: {
    problemsSaved: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      configurationToDelete: 0,
    };
  },
  methods: {
    goDetailSolving({ id: problemId, text: name }) {
      this.$router.push({
        name: 'HelpDetailSolving',
        query: {
          name,
          problem: problemId,
        },
      });
    },
    confirmationDelete(id) {
      this.configurationToDelete = id;
      this.$refs.modalConfirmation.openModal();
    },
    handleDeleteProblemSaved() {
      this.$emit('onClickDelete', { problemId: this.configurationToDelete });
      this.configurationToDelete = 0;
    },
  },
};
</script>
